export const getLocationName = (pathname: string) => {
    const pathNames = pathname.split("/")
    return pathNames.splice(1, 2)
}
